import client from '../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../utils/redux-tool'

const name = 'staff'
const initialState = {
  selected: null,
  list: [],
}

export const search = createApiAction(
  'academic-year-enrollment/search',
  client.search('/api/:employmentType/:personId/academic-year-enrollment'),
) 
export const get = createApiAction(
  'academic-year-enrollment/get',
  client.retrieve(`/api/:employmentType/:personId/academic-year-enrollment/:id`),
)
export const save = createApiAction(
  'academic-year-enrollment/save',
  client.save('/api/:employmentType/:personId/academic-year-enrollment'),
)
export const destroy = createApiAction(
  'academic-year-enrollment/delete',
  client.destroy('/api/:employmentType/:personId/academic-year-enrollment/:id'),
)

const updateAcademicYearList = (state, action) => {
  const found = state.list.find(rec => rec.id === action.payload.id)
  state.list = found
    ? state.list.map(rec => (found.id === rec.id ? action.payload : rec))
    : [...state.list, action.payload]
}

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    select: (state, action) => {
      state.selected = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, state => {
        state.list = []
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(get.fulfilled, updateAcademicYearList)
      .addCase(save.fulfilled, updateAcademicYearList)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(rec => rec.id !== action.payload.id)
        state.selected = null

      })
  },
})

export const { select } = sessionSlice.actions
export default sessionSlice.reducer
